import { serviceName } from '@utils/find-name';

import { Services } from '@customTypes/Service';

interface Props {
  serviceId?: number;
  serviceIds: number[];
  canSelectNone?: boolean;
  onSelect: (newServiceId?: number) => void;
  services: Services;
}

const ServiceSelect: React.FC<Props> = (props) => {
  const { serviceId, serviceIds, services, canSelectNone, onSelect } = props;
  return (
    <select
      value={serviceId}
      onChange={(e) => onSelect(parseInt(e.target.value) || undefined)}
      className={`service-select ${!serviceId ? '' : 'selected'}`}
    >
      {canSelectNone ? <option>전체 서비스</option> : null}
      {serviceIds.map((sId) => (
        <option key={sId} value={sId}>
          {serviceName(sId, services)}
        </option>
      ))}
    </select>
  );
};

export default ServiceSelect;
